import { JsonSchemaFormService } from '@ajsf/core';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ILayoutNode, IOptions } from '../custom-form-widget-interfaces';

@Component({
  selector: 'pr-custom-form-signature-widget',
  templateUrl: './custom-form-signature-widget.component.html',
  styleUrls: ['./custom-form-signature-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomFormSignatureWidgetComponent implements OnInit {
  formControl: FormControl;
  controlName: string;
  controlValue: string;
  controlDisabled = false;
  boundControl = false;
  options: IOptions;
  @Input() layoutNode: ILayoutNode;
  @Input() layoutIndex: number[];
  @Input() dataIndex: number[];

  constructor(private _jsf: JsonSchemaFormService) {}

  ngOnInit(): void {
    this.options = this.layoutNode.options || {};
    this._jsf.initializeControl(this);
    if (
      !this.options.notitle &&
      !this.options.description &&
      this.options.placeholder
    ) {
      this.options.description = this.options.placeholder;
    }
    this.formControl.setValidators(
      this.options.required ? [Validators.required] : []
    );
  }

  getLabel(options: IOptions): string | undefined {
    return options.notitle ? '' : options.title;
  }
}
